import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';
import { SafetyService } from '../../../../services/safety/safety.service';
import { Safety, SafetyCategory, SafetyReport } from '../../../../models/safety/safety.models';
import { ValidationResultModel } from '../../../../_foundation/models/validation.models';
import { AppConfig } from '../../../../app/app.config';

/**
 * Generated class for the SafetyReportEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-safety-report-edit',
  templateUrl: 'safety-report-edit.html',
})
export class SafetyReportEditPage {
  config = AppConfig.settings;

  editor: SafetyReport;
  editorNew: SafetyReport;
  model: Safety;
  categories: SafetyCategory[] = [];
  isCreate: boolean;
  validationResult: ValidationResultModel;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private safetyService: SafetyService,
              public events: Events,
  ) {
    this.editor = this.navParams.get('editor');
    this.editorNew = Object.assign({}, this.editor);
    this.model = this.navParams.get('model');
    this.isCreate = this.navParams.get('isCreate');
    this.categories = this.model.readings.map(e => e.category);
  }

  ionViewDidLoad() {

  }

  compareFn(e1: SafetyCategory, e2: SafetyCategory): boolean {
    return e1 && e2 ? e1.id === e2.id : e1 === e2;
  }

  save() {
    this.safetyService.validateReport(this.editorNew).subscribe(() => {
        if (this.isCreate) {
          this.model.reports.push(this.editorNew);
        } else {
          const index = this.model.reports.findIndex(value => value.id === this.editorNew.id);
          this.model.reports[index] = this.editorNew;
        }

        this.events.publish('saveSafety');

        this.navCtrl.pop();

      },
      error => {
        if (error.status && error.status === 412) {
          this.validationResult = error.error;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/safety/safety-report-edit/safety-report-edit.ts